import { FaTools, FaCalendar, FaClock, FaMapMarkerAlt, FaUserTie, FaEnvelope, FaDollarSign, FaUser, FaTags, FaBusinessTime, FaBriefcase, FaMoneyBillWave, FaHourglassEnd, FaCalendarAlt, FaCogs, FaOilCan, FaCar, FaCarBattery, FaSearch, FaHandshake, FaChartLine, FaCarCrash, FaBullhorn, FaWarehouse, FaCalendarCheck, FaStar, FaWrench, FaSync, FaKey, FaMapMarkedAlt, FaHeadset, FaWallet, FaGlobe, FaTag, FaCarSide, FaGasPump, FaUserFriends, FaRoad, FaExchangeAlt, FaBolt, FaTachometerAlt, FaTruckMonster, FaPhone } from 'react-icons/fa';
import { FaHandHoldingDollar } from 'react-icons/fa6';


// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'car maintenance':
      return <FaTools />; // Return the FaTools icon for car maintenance
    case 'tire services':
      return <FaCogs />; // Return the FaCogs icon for tire services
    case 'oil change':
      return <FaOilCan />; // Return the FaOilCan icon for oil change
    case 'brake services':
      return <FaCar />; // Return the FaCar icon for brake services
    case 'battery services':
      return <FaCarBattery />; // Return the FaCarBattery icon for battery services
    case 'car inspection':
      return <FaSearch />; // Return the FaSearch icon for car inspection


    /*----- Position Icons -----*/
    case 'sales executive':
      return <FaHandshake />; // Return the FaHandshake icon for sales executive
    case 'service advisor':
      return <FaTools />; // Return the FaTools icon for service advisor
    case 'finance manager':
      return <FaChartLine />; // Return the FaChartLine icon for finance manager
    case 'technician':
      return <FaCarCrash />; // Return the FaCarCrash icon for technician
    case 'marketing specialist':
      return <FaBullhorn />; // Return the FaBullhorn icon for marketing specialist
    case 'product manager':
      return <FaMapMarkerAlt />; // Return the FaMapMarkerAlt icon for product manager


    /*----- Event Single -----*/
    case 'date':
      return <FaCalendar />; // Calendar icon for date selection
    case 'time':
      return <FaClock />; // Clock icon for time selection
    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon for location
    case 'organizer':
      return <FaUserTie />; // UserTie icon for event organizer
    case 'number':
      return <FaPhone />; // Phone icon for contact numbers
    case 'email':
      return <FaEnvelope />; // Envelope icon for email input
    case 'fee':
    case 'revenue':
    case 'price':
      return <FaDollarSign />; // Dollar sign icon for fees/cost


    /*----- Portfolio Single -----*/
    case 'audience':
      return <FaUser />; // User icon representing the audience or client
    case 'category':
      return <FaTags />; // Tags icon representing the project category
    case 'duration':
      return <FaClock />; // Clock icon representing the project duration


    /*----- Career Single -----*/
    case 'timing':
      return <FaClock />; // Clock icon for general timing
    case 'hours':
      return <FaBusinessTime />; // BusinessTime icon for working hours
    case 'experience':
      return <FaBriefcase />; // Briefcase icon for experience level
    case 'position':
      return <FaUserTie />; // UserTie icon for job position
    case 'days':
      return <FaCalendarAlt />; // Calendar icon for days worked
    case 'salary':
      return <FaMoneyBillWave />; // MoneyBillWave icon for salary representation
    case 'deadline':
      return <FaHourglassEnd />; // HourglassEnd icon for deadline


    /*----- Dealer Single -----*/
    case 'website':
      return <FaGlobe />; // Globe icon representing the dealer's website
    case 'listings':
      return <FaWarehouse />; // Warehouse icon representing available listings
    case 'availability':
      return <FaCalendarCheck />; // CalendarCheck icon representing availability status
    case 'specialties':
      return <FaStar />; // Star icon representing dealer specialties
    case 'reviews':
      return <FaStar />; // Star icon representing customer reviews


    /*----- Car Single -----*/
    case 'year':
      return <FaCalendarAlt />; // Calendar icon for the car's year
    case 'carmake':
      return <FaCar />; // Car icon for the manufacturer
    case 'carmodel':
      return <FaTag />; // Tag icon representing the model
    case 'cartype':
      return <FaCarSide />; // Car side view for type of car
    case 'passengers':
      return <FaUserFriends />; // User friends icon for passenger capacity
    case 'fueltype':
      return <FaGasPump />; // Gas pump icon for fuel type
    case 'mileage':
      return <FaRoad />; // Road icon representing mileage
    case 'engine':
      return <FaCogs />; // Cogs icon for engine specifications
    case 'transmission':
      return <FaExchangeAlt />; // Exchange arrows icon for transmission type
    case 'horsepower':
      return <FaBolt />; // Bolt icon representing power output
    case 'topspeed':
      return <FaTachometerAlt />; // Speedometer icon for top speed
    case 'drivetrain':
      return <FaTruckMonster />; // Off-road vehicle icon for drivetrain (AWD, FWD, etc.)


    /*----- Support Tab Buttons -----*/
    case 'vehicle inventory':
      return <FaCar />; // Car icon representing vehicle inventory
    case 'financing options':
      return <FaHandHoldingDollar />; // HandHoldingDollar icon representing financing options
    case 'maintenance guides':
      return <FaWrench />; // Wrench icon representing maintenance guides
    case 'trade in evaluation':
      return <FaSync />; // Sync icon representing trade-in evaluation
    case 'schedule test drive':
      return <FaKey />; // Key icon representing test drive scheduling
    case 'dealership locations':
      return <FaMapMarkedAlt />; // MapMarkedAlt icon representing dealership locations
    case 'customer support':
      return <FaHeadset />; // Headset icon representing customer support
    case 'roadside assistance':
      return <FaWallet />; // Wallet icon representing roadside assistance costs or services

    default:
      return null; // Return null if no matching icon is found

  }

};